import React from 'react'
import Navbar from '../../components/Navbar'
import Footer from '../../components/Footer'
import PreNav from '../../components/PreNav'
import { useDispatch } from 'react-redux'
import {logout} from "../../redux/actions/userAction"
import { useNavigate } from 'react-router-dom'

const UserLayout = ({children}) => {

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const handleLogout = () => {
        dispatch(logout())
        .then(res=>{
            if (res.success) {
                navigate('/')
            }
        })
    }

  return (
    <>
    <PreNav/>
    <Navbar/>
        <section className="pt-7 pb-12">
            <div className="container">
            <div className="row">
                <div className="col-12 text-center">
                {/* Heading */}
                <h3 className="mb-10">My Account</h3>
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-3">
                {/* Nav */}
                <nav className="mb-10 mb-md-0">
                    <div className="list-group list-group-sm list-group-strong list-group-flush-x">
                    <a className="list-group-item list-group-item-action d-flex justify-content-between active" href="/user/myorders">
                        Orders <i className="bi bi-arrow-right"></i>
                    </a>
                    <a className="list-group-item list-group-item-action d-flex justify-content-between " href="/user/wishlist">
                        Wishlist
                        <i className="bi bi-arrow-right"></i>
                    </a>
                    <a className="list-group-item list-group-item-action d-flex justify-content-between " href="/user/me">
                        Personal Info
                        <i className="bi bi-arrow-right"></i>
                    </a>
                    <a className="list-group-item list-group-item-action d-flex justify-content-between " href="/user/addresses">
                        Addresses
                        <i className="bi bi-arrow-right"></i>
                    </a>
                    <a className="list-group-item list-group-item-action d-flex justify-content-between text-danger cursor-pointer" onClick={handleLogout}>
                        Logout
                        <i className="bi bi-arrow-right"></i>
                    </a>
                    </div>
                </nav>
                </div>
                <div className="col-12 col-md-9 col-lg-8 offset-lg-1">
                    {children}
                </div>
            </div>
            </div>
        </section>
        <Footer/>
    </>
  )
}

export default UserLayout